module.exports = __webpack_public_path__ + "media/images/ico-circle-times-teal-5d4f57bd.svg";